module.exports = __webpack_public_path__ + "static/img/zwsj.e17330c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zwsj.png
// module id = wsSu
// module chunks = 52